<template>
    <div>
        <div class="modal-body text-center m-1">
            <input
                @change="onChangeCSV($event)"
                type="file"
                name="file"
                accept=".csv"
                class="form-control"
            >
        </div>
        <div class="modal-footer">
            <button
                :disabled="disabledModalBtn"
                type="button"
                class="btn btn-danger"
                @click="closeModal"
            >
                Close
            </button>
            <button @click="sendEvents" :disabled="disabledModalBtn" class="btn btn-primary">Upload</button>
        </div>
    </div>
</template>

<script>
    import { notification } from '../../../../helpers/notification'
    export default {
        name: 'UploadsEventsModal',
        props: {
            id: {
                type: Number
            }
        },
        data: () => ({
            files: [],
            uploadData: false,
            showSuccessAlert: false
        }),
        methods: {
            onChangeCSV(e) {
                let file = e.target.files
                for (let csv in file) {
                    this.files.push(file[csv])
                }
            },
            async sendEvents() {
                this.uploadData = true
                try {
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData()
                    formData.append('venue_id', this.id)
                    formData.append('file', this.files[0])
                    await axios.post('/admin/import-venue-events/csv',
                        formData,
                        config
                    )
                    this.uploadData = false
                    this.showSuccessAlert = true
                    this.$emit('update:showSuccessAlert', this.showSuccessAlert)
                    this.closeModal()
                } catch (e) {
                    this.uploadData = false
                    notification('error', e)
                }
            },
            closeModal() {
                this.$emit('closeModal')
            }
        },
        computed: {
            disabledModalBtn() {
                return this.uploadData
            }
        }
    }
</script>
